import React, {Component} from 'react';
import {Link} from 'react-router';
import T from 'i18n-react';
import {connect} from 'react-redux';
import debounce from "lodash.debounce";
// WebServices
import UserService from '../../services/UserService';
// Style
import './UserDashboardPage.css';
// Composants
import SortComponent from '../../components/sort/SortComponent';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import DialogAlert from '../../components/dialogAlert/DialogAlert';
import MaterialFormInput from '../../components/materialFormInput/MaterialFormInput';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import Pagination from '../../components/pagination/Pagination';
// Utils
import {makeCancelable} from '../../utils/PromiseUtils';
// Service
import {exportUserData} from '../../utils/ExportCsvUtils';
// Enum
import PROFILES from '../../enums/ProfileEnum';
import PAGES from '../../enums/PageEnum';
import SORTABLE_USER_COLUMNS from '../../enums/SortableUserColumnsEnum';
import SORT from '../../enums/SortEnum';

const mapStateToProps = (state) => ({
    idUser: state.userState.userData.idUser,
    userProfile: state.userState.userData.profile,
    userBu: state.userState.userData.businessUnit,
    language: state.languageState.language
});

const USER_BY_PAGE_OPTIONS = [10, 20, 50];

class UserDashboardPage extends Component {

    /**********************************************************
     * ******************** LifeCycle *************************
     **********************************************************/

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isLoaded: false,
            selectedBu: props.userBu,
            buList: undefined,
            superUserList: undefined,
            shopUserList: [],
            userList: [],
            totalUserList: 0,
            error: null,
            openDialog: false,
            idUserToDelete: null,
            profileTab: UserService.getAvailableProfileForUser(props.userProfile),
            openImportUserDialog : false
        };

        this.table = {
            userByPage: USER_BY_PAGE_OPTIONS[0],
            page: 1,
            columnToSortList: [SORTABLE_USER_COLUMNS.FIRST_NAME, SORTABLE_USER_COLUMNS.LAST_NAME],
            sort: SORT.ASC,
            search: "",
            profile: 0
        };

        this._promises = [];
        this.getUserInformationListDebounced = debounce(this.getUserInformationList, 300);
    }

    /**
     * Au chargement de la page on récupère la liste des shops
     */
    componentWillMount() {
        this.setState({
            isLoading: true
        }, () => {
            this.getUserInformationList();
        });
    }

    /**
     * On set le system de notification
     */
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
        this.getUserInformationListDebounced.cancel();
    }

    /**
     * Regle de gestion sur la modification des users
     * @param {*} user
     */
    canEditProfile(user){
        // Un utilisateur peut modifier son compte peu importe son status
        if (user.idUser === this.props.idUser) {
            return true;
        } else if(user.profile === this.props.userProfile && user.canManageUsers){
            //Un utilisateur ne peut pas modifier un autre utilisateur de même rang qui a l'option de gestion des utilisateurs
            return false;
        }else {
            //Seuls les profils contenus dans le tableau des profils autorisée pour l'utilisateur connecté peuvent être modifiés
            return this.state.profileTab.includes(user.profile);
        }
    }

    /**
     * Regle de gestion sur la suppression des users
     * @param {*} user
     */
    canDeleteProfile(user){
        // Un utilisateur ne peut pas supprimer son compte et un AdminMp ne peut pas être supprimé
        //Un utilisateur ne peut pas supprimer un autre utilisateur de même rang qui a l'option de gestion des utilisateurs
        if (user.idUser === this.props.idUser || user.profile === PROFILES.ADMIN_MP || (user.profile === this.props.userProfile && user.canManageUsers)) {
            return false;
        } else {
            //Seuls les profils contenus dans le tableau des profils autorisée pour l'utilisateur connecté peuvent être supprimés
            return this.state.profileTab.includes(user.profile);
        }
    }

    renderRow(index, user) {
        let canEdit = this.canEditProfile(user);
        let canDelete = this.canDeleteProfile(user);
        return (
            <tr key={index} className={"userDashboardTableRow"}>
                <td className="userDashboardTableCell tooltipUser">
                    <div>{user.firstName} {user.lastName}</div>
                    <span className="hooverTextUser"> {user.firstName} {user.lastName} </span>
                </td>
                <td className="userDashboardTableCell tooltipUser">
                    <div>
                        {T.translate(`userProfile.${user.profile}`)}
                        {' '}
                        {user.canManageUsers ? <FontIcon className="material-icons" style={{fontSize: 'inherit'}}>people</FontIcon> : ''}
                    </div>
                    <span className="hooverTextUser"> {T.translate(`userProfile.${user.profile}`)} </span>
                </td>
                <td className="userDashboardTableCell tooltipUser">
                    <div>{this.renderClientName(user)}</div>
                </td>
                <td className="userDashboardTableCell tooltipUser">
                    <div>{this.renderBusinessUnitName(user)}</div>
                </td>
                <td className="userDashboardTableCell">
                    <div>{this.renderShopName(user)}</div>
                </td>
                <td className="userDashboardTableCell tooltipUser">
                    <div>{user.email}</div>
                    <span className="hooverTextUser"> {user.email} </span>
                </td>
                <td className="userDashboardTableCell tooltipUser">
                    <div>{user.login}</div>
                    <span className="hooverTextUser"> {user.login} </span>
                </td>
                <td className="userDashboardTableCell tooltipUser phoneNumberColumn">
                    <div>{user.phoneNumber}</div>
                    <span className={user.phoneNumber ? "hooverTextUser" : ""}> {user.phoneNumber} </span>
                </td>
                <td className="userDashboardTableCell buttonCell">
                    <Link to={canEdit ? PAGES.USER_EDIT.replace(':idUser', user.idUser) : null} style={{display: 'flex', justifyContent: 'center', flexDirection:'column', textDecoration: 'none'}}>
                        <FontIcon className="material-icons"
                                  color={canEdit ? null : "#ABABAB"}>
                            edit
                        </FontIcon>
                    </Link>
                    <div className="verticalDividerContainer">
                        <div className="verticalDivider"/>
                    </div>
                    <IconButton onClick={this.deleteAction.bind(this, user.idUser)}
                                disabled={!canDelete}>
                        <FontIcon className="material-icons">delete</FontIcon>
                    </IconButton>
                </td>
            </tr>
        );
    }

    renderClientName(user) {
        //Si c'est un adminMP => tous
        if(user.profile === PROFILES.ADMIN_MP){
            return T.translate('manageUser.all');
        }
        //Si c'est un Admin, SuperUser ou un user => ses clients
        if((user.profile === PROFILES.USER || user.profile === PROFILES.SUPER_USER || user.profile === PROFILES.ADMIN) && user.clientList && user.clientList.length > 0){
            const clientList = user.clientList.map((client, index) => {
                return <li key={index}>{client.name}</li>;
            });
            return (
                <div>
                    <ul className="cellList">
                        {clientList}
                    </ul>
                    <ul className="hooverTextUser">
                        {clientList}
                    </ul>
                </div>
            );
        }

        return '';
    }

    renderBusinessUnitName(user) {
        //Si c'est un adminMP ou ADMIN => toutes (des clients associés)
        if(user.profile === PROFILES.ADMIN_MP || user.profile === PROFILES.ADMIN){
            return T.translate('manageUser.alles');
        }
        //Si c'est un superUser ou un user => ses bu
        if((user.profile === PROFILES.USER || user.profile === PROFILES.SUPER_USER) && user.businessUnitList && user.businessUnitList.length > 0){
            const buList = user.businessUnitList.map((bu, index) => {
                return <li key={index}>{bu.name}</li>;
            });
            return (
                <div>
                    <ul className="cellList">
                        {buList}
                    </ul>
                    <ul className="hooverTextUser">
                        {buList}
                    </ul>
                </div>
            );
        }

        return '';
    }

    renderShopName(user) {
        //Si c'est un adminMP ou un admin ou un superUser => tout
        if(user.profile === PROFILES.ADMIN_MP || user.profile === PROFILES.ADMIN || user.profile === PROFILES.SUPER_USER){
            return T.translate('manageUser.all');
        } else {
            //Si c'est un user => le shop
            if(user.shopList && user.shopList.length > 0){
                return <div key={0}>{user.shopList[0].name}</div>;
            }
            return '';
        }
    }

    renderContent(users) {
        let rowTab = [];
        for(let i in users) {
            rowTab.push(this.renderRow(i, users[i]));
        }

        return rowTab;
    }

    render() {
        return (
            <div className="pageContent">
                <DialogAlert title={T.translate('deleteModal.title')}
                             text={T.translate('deleteModal.text')}
                             open={this.state.openDialog}
                             action={this.deleteUser}
                             close={() => {this.setState({'openDialog': false})}}
                             param={this.state.idUserToDelete} />
                <div className="topHeaderUserDashboard">
                    <span className="headerTitleUserDashboard">{T.translate('menuTop.userManagement')}</span>
                    <Link to={PAGES.USER_ADD}>
                        <RaisedButton className="simpleButton"
                                      secondary
                                      label={T.translate("tableHeader.addUser")}
                                      icon={<FontIcon className="material-icons" color={"white"}>add</FontIcon>}
                        />
                    </Link>
                </div>
                <div className="formContent">
                    <div className="form">
                        <DropDownMenu className='profileDropdown'
                                      value={this.table.profile}
                                      onChange={(event, key, value) => {
                                        this.table.profile = value;
                                        this.table.page = 1;
                                        this.getUserInformationList();
                                      }}>
                            <MenuItem key={0}
                                      value={0}
                                      primaryText={T.translate("manageUser.all")} />
                            {
                                this.state.profileTab.map((value, index) => {
                                    return <MenuItem key={index + 1}
                                                     id={index + 1}
                                                     value={value}
                                                     primaryText={T.translate("userProfile." + value)} />
                                })
                            }
                        </DropDownMenu>
                        <div className="formLabel">{T.translate('manageUser.search')} :</div>
                        <MaterialFormInput
                            id="searchInput"
                            className="searchInput"
                            onChange={(event, value) => {
                                this.table.search = value;
                                this.table.page = 1;
                                this.getUserInformationListDebounced();
                            }}
                        />
                    </div>
                </div>
                <div className="userDashboardContent">
                    <table className="userDashboardTable">
                        <thead className="userDashboardTableHeader">
                            <tr className="userDashboardTableRow">
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div><SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_USER_COLUMNS.FIRST_NAME}
                                                   action={this.setSortedColumnList.bind(this, [SORTABLE_USER_COLUMNS.FIRST_NAME, SORTABLE_USER_COLUMNS.LAST_NAME])}
                                                   text={T.translate('manageUser.name')}/></div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div>{T.translate('manageUser.profile')}</div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div>{T.translate('manageUser.client')}</div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div>{T.translate('manageUser.society')}</div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div>{T.translate('manageUser.shop')}</div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div><SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_USER_COLUMNS.EMAIL}
                                                   action={this.setSortedColumnList.bind(this, [SORTABLE_USER_COLUMNS.EMAIL])}
                                                   text={T.translate('manageUser.email')}/></div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header">
                                    <div><SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_USER_COLUMNS.LOGIN}
                                                   action={this.setSortedColumnList.bind(this, [SORTABLE_USER_COLUMNS.LOGIN])}
                                                   text={T.translate('manageUser.login')}/></div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header phoneNumberColumn">
                                    <div>{T.translate('manageUser.phoneNumber')}</div>
                                </th>
                                <th className="userDashboardTableCell userDashboardTableCell-header buttonCell"></th>
                            </tr>
                        </thead>
                        <tbody className="userDashboardTableTBody">
                            {this.renderContent(this.state.userList)}
                        </tbody>
                    </table>
                </div>

                <div className="userDashboardFooter">
                    <Pagination total={parseInt(this.state.totalUserList, 10)}
                                rowsPerPage={USER_BY_PAGE_OPTIONS}
                                page={parseInt(this.table.page, 10)}
                                numberOfRows={parseInt(this.table.userByPage, 10)}
                                updateRows={(state) => {
                                    this.table.page = state.page;
                                    this.table.userByPage = state.numberOfRows;
                                    this.getUserInformationList();
                                }}/>
                    <RaisedButton label="CSV" className="simpleButton" onClick={this.exportUserCsv}>
                    </RaisedButton>
                </div>
            </div>
        );
    }

    setSortedColumnList(columnToSortList) {
        if(this.table.columnToSortList[0] === columnToSortList[0]) {
            this.table.sort = this.table.sort === SORT.ASC ? SORT.DESC : SORT.ASC;
        } else {
            this.table.sort = SORT.ASC;
            this.table.columnToSortList = columnToSortList;
        }

        this.getUserInformationList();
    }

    /**********************************************************
     ***************** Configuration composants ***************
     **********************************************************/


    /**********************************************************
     * **************** Appels Web Service ********************
     **********************************************************/

    getUserInformationList = () => {
        const getUsersInformationPromise = UserService.getUserInformationList(
            this.table.page,
            this.table.userByPage,
            this.table.profile === 0 ? null : this.table.profile,
            this.table.search,
            this.table.sort,
            this.table.columnToSortList
        );

        const cancelablePromise = makeCancelable(getUsersInformationPromise);
        this._promises.forEach(promise => promise.cancel());
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                this.setState({
                    userList: res.resourceList,
                    totalUserList: res.total,
                    isLoading: false,
                    isLoaded: true
                })

            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        isLoading: false,
                        isLoaded: true,
                        error
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    /**
     * Supprime un utilisateur donné
     * @param idUser
     */
    deleteUser = (idUser) => {

        this.setState({'openDialog' : false});
        UserService.deleteUser(idUser)
            .then(() => {
                this.getUserInformationList();
                this._addNotification(T.translate('manageUser.deleteUser.success'), 'success');
            })
            // On ne fait rien car si il y a une erreur c'est forcement une 500
            // donc déjà géré par le store
            .catch(() => {});
    };

    /**********************************************************
     * **************** Actions composants ********************
     **********************************************************/

    /**
     * Ouvre la popUp de confirmation avant de delete l'utilisateur
     */
    deleteAction(idUser) {
        this.setState({'openDialog': true, 'idUserToDelete': idUser})
    }

    /**
     * Récupère la valeur à afficher dans l'export CSV pour le client
     * @param user
     */
    getClientDisplayName(user){
        if(PROFILES.ADMIN_MP === user.profile){
            return T.translate('manageUser.all');
        } else if((user.profile === PROFILES.USER || user.profile === PROFILES.SUPER_USER || user.profile === PROFILES.ADMIN) && user.clientList && user.clientList.length > 0){
            return user.clientList.map(client => client.name).join(' | ');
        } else {
            return '';
        }
    }

    /**
     * Récupère la valeur à afficher dans l'export CSV pour la BU
     * @param {} user
     */
    getBuDisplayName(user) {
        if (user.businessUnitList) {
            return user.businessUnitList.map(client => client.name).join(' | ');
        } else if (user.profile === PROFILES.ADMIN && user.locationList && user.locationList.length > 0) {
            return T.translate('manageUser.alles') + ' ' + user.locationList[0];
        } else {
            return T.translate('manageUser.alles');
        }
    }

    /**
     * Récupère la valeur à afficher dans l'export CSV pour le magasin
     * @param {*} user
     */
    getShopDisplayName(user) {
        let displayShopName = '';
        if(user.shopList) {
            user.shopList.forEach((shop) => {
                displayShopName += ` ${shop.name}`
            })
        } else {
            displayShopName = T.translate('manageUser.all');
        }
        return displayShopName
    }

    /**
     * Formate les données pour l'export CSV
     */
    formatUserCsvData = (userList) => {
        let dataList = [];
        userList.forEach((item) => {
            const name = `${item.firstName} ${item.lastName}`;
            let userInfos = [
                '"' + name + '"',
                '"' + T.translate(`userProfile.${item.profile}`) + '"',
                '"' + this.getClientDisplayName(item) + '"',
                '"' + this.getBuDisplayName(item) + '"',
                '"' + this.getShopDisplayName(item) + '"',
                '"' + item.email + '"',
                '"' + item.login + '"',
                '"' + (!item.phoneNumber ? '' : '\''+item.phoneNumber) + '"',
                '"' + (item.canManageUsers ? "OUI" : "NON") + '"'
            ];

            dataList.push(userInfos);
        });
        return dataList;
    };

    exportUserCsv = () => {
        UserService.getUserInformationListForExport().then((res) => {
            const formattedData = this.formatUserCsvData(res.resourceList);
            const filename = "users.csv";
            exportUserData(formattedData, filename);
        })
    };

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise) {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 60,
            level,
            position: 'tr'
        });
    }

}

export default connect(mapStateToProps)(UserDashboardPage);



// WEBPACK FOOTER //
// ./src/ui/userDashboard/UserDashboardPage.js